import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

const STORE_NAME = 'Platforms';

export type PlatformsStoreState = {
  searchQuery: string;
  setSearchQuery: (searchQuery: string) => void;
};

const initialState = {
  searchQuery: '',
};

export const usePlatformsStore = create<PlatformsStoreState>()(
  devtools(
    (set) => ({
      ...initialState,
      setSearchQuery: (searchQuery) => set(() => ({ searchQuery })),
    }),
    { name: STORE_NAME },
  ),
);
